module.exports = __webpack_public_path__ + "static/media/7-iveco-mercedes.5659db59.jpg";